<main class="circle-gradient-1">
    <section class="breadcrumb-sec event-sec">
        <div class="container">
            <div class="row g-0">
                <div class="col-lg-6 col-md-6">
                    <ul class="breadcrumb">
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a routerLink="/events">Events</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a routerLink="/events" fragment="academic">Academic</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li>Guest lecturer on Gender Sensitization</li>
                    </ul>
                    <div class="sec-title">
                        <h1><span>Guest lecturer on Gender Sensitization</span></h1>

                        <p>Computer Science department, GHRCACS,Pune organized a Guest lecturer on Gender Sensitization
                            on Wednesday24th September 2025.</p>
                    </div>
                </div>
            </div>
            <div class="breadcrumb-overlay overflow-hidden"
                style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-2.webp);">
            </div>
        </div>
    </section>
    <section class="section-lg">
        <div class="container">
            <div class="sec-title text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="demo-gallery">
                <ul appLightgallery>
                    <li class="grid-item1"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-1.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-1.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-1.webp">
                        </a>
                    </li>
                    <li class="grid-item2"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-2.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-2.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-2.webp">
                        </a>
                    </li>
                    <li class="grid-item3 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-5.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-5.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-5.webp">
                        </a>
                    </li>
                    <!-- <li class="grid-item4 "
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-4.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-4.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-4.webp">
                        </a>
                    </li>
                    <li class="grid-item5 "
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-5.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-5.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-5.webp">
                        </a>
                    </li> -->
                </ul>
            </div>
        </div>
    </section>
</main>
